import { useToast } from '@chakra-ui/react';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useHistory } from 'react-router';
import { getInvoiceById, getInvoices } from '~/services';
import { InvoiceView, Pagination } from '~/types';
import { QueryFilterContext } from '~/hooks/useFilter/types';

export function useInvoices(
  page: number,
  search = '',
  invoiceStatus = '',
  periodo_inicial = '',
  periodo_final = '',
  orderby = '',
  order = '',
  query: QueryFilterContext,
  pageSize: number,
  options: UseQueryOptions<Pagination<InvoiceView>, unknown> = {},
): UseQueryResult<Pagination<InvoiceView>, unknown> {
  const toast = useToast();
  const arrGroups = query.groups?.map(e => e.value);
  const arrHeadOffices = query.headOffices?.map(e => e.value);
  const arrBrancches = query.branches?.map(e => e.value);

  return useQuery<Pagination<InvoiceView>, unknown>(
    [
      'invoices',
      page,
      search,
      invoiceStatus,
      periodo_inicial,
      periodo_final,
      orderby,
      order,
      { arrGroups, arrHeadOffices, arrBrancches },
      pageSize,
    ],
    () =>
      getInvoices(
        page,
        search,
        invoiceStatus,
        periodo_inicial,
        periodo_final,
        orderby,
        order,
        {
          groups: arrGroups,
          headoffices: arrHeadOffices,
          branches: arrBrancches,
        },
        pageSize,
      ),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro buscar faturas, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}

export function useInvoice(
  id: number,
  options: UseQueryOptions<InvoiceView, unknown> = {},
): UseQueryResult<InvoiceView> {
  const toast = useToast();
  const history = useHistory();

  return useQuery<InvoiceView, unknown>(
    ['invoice', id],
    () => getInvoiceById(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro buscar detalhes da fatura',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        history.goBack();
      },
    },
  );
}
